export const TypeAddress = {
  POI: 0,
  Address: 1,
  Favorite: 2,
};

export type TypeAddress = (typeof TypeAddress)[keyof typeof TypeAddress];
export type TypeAddressLabelType = (typeof TypeAddressLabel)[TypeAddress];

export const TypeAddressLabel: Record<TypeAddress, string> = {
  [TypeAddress.POI]: "poi",
  [TypeAddress.Address]: "address",
  [TypeAddress.Favorite]: "favorite",
};
